
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltySubscriptionUpdateForm from '@/form/loyalty/loyaltySubscription/LoyaltySubscriptionUpdateForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltySubscriptionUpdateFormComponent extends Vue {
    @Prop() form!: LoyaltySubscriptionUpdateForm;
}
